import type { Preset } from "mws-framethegame-ts-sdk";

export type ProductDetailStore = {
  selectedPreset: Ref<Preset | undefined>;
  setSelectedPreset: (preset?: Preset) => void;
};

export const PRODUCT_DETAIL_STORE_KEY: InjectionKey<ProductDetailStore> =
  Symbol("PRODUCT_DETAIL_STORE");

export const useProvideProductDetailStore = () => {
  const selectedPreset = ref<Preset | undefined>(undefined);

  const store: ProductDetailStore = {
    selectedPreset: readonly(selectedPreset),
    setSelectedPreset: (newPreset) => (selectedPreset.value = newPreset),
  };

  provide(PRODUCT_DETAIL_STORE_KEY, store);

  return store;
};

export const useInjectProductDetailStore = () => {
  const resolved = inject(PRODUCT_DETAIL_STORE_KEY);

  if (!resolved) {
    throw new Error(`${PRODUCT_DETAIL_STORE_KEY.toString()} was not provided.`);
  }

  return resolved;
};
